module.exports = __webpack_public_path__ + "img/black_knight.30d1208a.png";